import dateTimeFormatter from 'src/common/utils/date-time-formatter';

export const styleDateString = (dates, countryModel) => {
  if (!dates) {
    return;
  }

  const format = {
    day: 'numeric',
    month: 'long',
  };
  const earliest = dateTimeFormatter.date(dates.earliest, countryModel, format);
  const latest = dateTimeFormatter.date(dates.latest, countryModel, format);
  return `${earliest} - ${latest}`;
};

export const findType = (dates, type = 'standard') => dates.find(s => s.type === type);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Shipping/ShippingDate/helpers.js